import React from 'react';
import { motion } from 'framer-motion';
export function Slide3Engagement() {
  const metrics = [{
    label: 'Page Views',
    value: 73,
    max: 100,
    suffix: ''
  }, {
    label: 'Snak™ Engagers',
    value: 41,
    max: 100,
    suffix: ''
  }, {
    label: 'Unique Engagers',
    value: 39,
    max: 100,
    suffix: ''
  }, {
    label: 'Engagement Rate',
    value: 57,
    max: 100,
    suffix: '%'
  }, {
    label: 'Avg View Time',
    value: 4.3,
    max: 5,
    suffix: 'm',
    displayValue: '4m 19s'
  }, {
    label: 'Total Clicks',
    value: 313,
    max: 400,
    suffix: ''
  }];
  // Engagement traffic by channel
  const segments = [{
    label: 'Flyer / QR codes',
    value: 63,
    color: '#0085bd'
  }, {
    label: 'LinkedIn posts',
    value: 29,
    color: '#94A3B8'
  }, {
    label: 'Booth engagement',
    value: 8,
    color: '#CBD5E1'
  }];
  // Build SVG donut segments
  const radius = 80;
  const circumference = 2 * Math.PI * radius;
  let cumulative = 0;
  const arcs = segments.map(seg => {
    const dash = seg.value / 100 * circumference;
    const arc = {
      ...seg,
      dash,
      gap: circumference - dash,
      offset: -(cumulative / 100) * circumference
    };
    cumulative += seg.value;
    return arc;
  });
  return <div className="flex flex-col h-full max-w-[1600px] mx-auto w-full" data-id="element-603">
      <div className="mb-8" data-id="element-604">
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-605">
          More than half of those who opened it chose to engage
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-606">
          In a high-distraction congress setting, 57% engagement is a strong
          performance — especially for a specialist company earning attention in
          a crowded category. The Snak worked as a QR-led engagement engine,
          with participation driven primarily through scan-based access.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 flex-1" data-id="element-607">
        {/* Metrics Bars */}
        <div className="space-y-6 bg-white p-8 rounded-3xl border border-slate-100 shadow-sm" data-id="element-608">
          {metrics.map((metric, i) => <div key={i} className="relative" data-id="element-609">
              <div className="flex justify-between mb-2" data-id="element-610">
                <span className="font-medium text-slate-700" data-id="element-611">
                  {metric.label}
                </span>
                <span className="font-bold text-minerva-dark" data-id="element-612">
                  {metric.displayValue || metric.value}
                  {metric.suffix}
                </span>
              </div>
              <div className="h-4 bg-slate-100 rounded-full overflow-hidden" data-id="element-613">
                <motion.div initial={{
              width: 0
            }} animate={{
              width: `${metric.value / metric.max * 100}%`
            }} transition={{
              duration: 1,
              delay: 0.2 + i * 0.1,
              ease: 'easeOut'
            }} className="h-full bg-minerva-blue rounded-full" data-id="element-614" />
              </div>
            </div>)}
        </div>

        {/* Engagement traffic pie chart */}
        <div className="bg-slate-50 p-8 rounded-3xl border border-slate-200 flex flex-col" data-id="element-615">
          <h3 className="text-xl font-bold text-slate-800 mb-2 text-center" data-id="element-616">
            Engagement traffic
          </h3>
          <p className="text-sm text-slate-500 text-center mb-6" data-id="element-617">
            Where participation actually came from
          </p>

          <div className="flex-1 flex items-center justify-center gap-8" data-id="element-618">
            {/* Donut */}
            <div className="relative shrink-0" data-id="element-619">
              <svg width="200" height="200" viewBox="0 0 200 200" data-id="element-620">
                <g transform="rotate(-90 100 100)" data-id="element-621">
                  {arcs.map((arc, i) => <motion.circle key={i} cx="100" cy="100" r={radius} fill="none" stroke={arc.color} strokeWidth="32" strokeDasharray={`${arc.dash} ${arc.gap}`} initial={{
                  strokeDashoffset: circumference
                }} animate={{
                  strokeDashoffset: arc.offset
                }} transition={{
                  duration: 1,
                  delay: 0.4 + i * 0.25,
                  ease: 'easeOut'
                }} data-id="element-622" />)}
                </g>
                <text x="100" y="94" textAnchor="middle" className="fill-slate-900 font-display font-bold" fontSize="28" data-id="element-623">
                  41
                </text>
                <text x="100" y="116" textAnchor="middle" className="fill-slate-400" fontSize="12" data-id="element-624">
                  engagers
                </text>
              </svg>
            </div>

            {/* Legend */}
            <div className="space-y-4" data-id="element-625">
              {segments.map((seg, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.6 + i * 0.2
            }} className="flex items-center gap-3" data-id="element-626">
                  <span className="w-3 h-3 rounded-sm shrink-0" style={{
                backgroundColor: seg.color
              }} data-id="element-627" />
                  <div data-id="element-628">
                    <div className="text-sm font-bold text-slate-800 leading-tight" data-id="element-629">
                      {seg.value}%
                    </div>
                    <div className="text-xs text-slate-500 leading-tight" data-id="element-630">
                      {seg.label}
                    </div>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}